import TTooltip from './tooltip'

TTooltip.install = Vue => {
  Vue.directive(TTooltip.name, TTooltip)
}

export default TTooltip



// WEBPACK FOOTER //
// ./src/module/tooltip/index.js